/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Estonian
export default {
  'fabric.editor.action': 'Toimingu kirje',
  'fabric.editor.action.description': 'Loo ja määra toiminguid',
  'fabric.editor.addAltText': 'Asetekst',
  'fabric.editor.alignImageCenter': 'Joonda keskele',
  'fabric.editor.alignImageLeft': 'Joonda vasakule',
  'fabric.editor.alignImageRight': 'Joonda paremale',
  'fabric.editor.altText': 'Alt tekst',
  'fabric.editor.alttext.validation': 'Eemaldage asetekstist kõik erimärgid.',
  'fabric.editor.annotate': 'Lisa märge',
  'fabric.editor.annotationToolbar': 'Annotatsioonide tööriistariba',
  'fabric.editor.backLink': 'Mine tagasi',
  'fabric.editor.blockCardUnavailable': 'Sisemine link on sõlmes {node} ja selle vaadet ei saa muuta',
  'fabric.editor.blockquote.description': 'Sisesta tsitaat või osund',
  'fabric.editor.bold': 'Rasvane kiri',
  'fabric.editor.cancelButton': 'Loobu',
  'fabric.editor.cardFloatingControls': 'Kaardi valikud',
  'fabric.editor.cellBackground': 'Lahtri tagataust',
  'fabric.editor.cellOptions': 'Lahtri valikud',
  'fabric.editor.clearAltTextEdit': 'Eemalda asetekst',
  'fabric.editor.clearCells': '{0, plural, one {Lahtri tühjendamine} other {Lahtrite tühjendamine}}',
  'fabric.editor.clearFormatting': 'Tühista vorming',
  'fabric.editor.clearLink': 'Tühjenda link',
  'fabric.editor.clearLinkText': 'Tühjenda tekst',
  'fabric.editor.closeAltTextEdit': 'Tagasi',
  'fabric.editor.closeFindReplaceDialog': 'Sulge',
  'fabric.editor.closeHelpDialog': 'Sulge abi dialoog',
  'fabric.editor.code': 'Kood',
  'fabric.editor.codeblock': 'Koodilõik',
  'fabric.editor.codeblock.description': 'Näita süntaksi esile tõstvat koodi',
  'fabric.editor.columns': 'Kujundused',
  'fabric.editor.columns.description': 'Loo lehte jaotiste abil',
  'fabric.editor.configPanel.cancel': 'Tühista',
  'fabric.editor.configPanel.fieldTypeError.isMultipleAndRadio': 'Valikut isMultiple ei saa kombineerida stiiliga: radio',
  'fabric.editor.configPanel.formType.addField': 'Lisa väli',
  'fabric.editor.configPanel.formType.removeField': 'Eemalda väli',
  'fabric.editor.configPanel.required': 'Kohustuslik väli',
  'fabric.editor.configPanel.submit': 'Esita',
  'fabric.editor.date': 'Kuupäev',
  'fabric.editor.date.description': 'Lisa kuupäev kalendri abil',
  'fabric.editor.decision': 'Otsus',
  'fabric.editor.decision.description': 'Saa otsustest ülevaade, et nende jälgimine oleks hõlpsam',
  'fabric.editor.decisionPlaceholder': 'Lisa otsus…',
  'fabric.editor.displayInline': 'Tekstisiseselt kuvamine',
  'fabric.editor.displayLink': 'Näita tekstina',
  'fabric.editor.displayText': 'Näidatav tekst',
  'fabric.editor.edit': 'Muuda',
  'fabric.editor.editAltText': 'Muuda aseteksti',
  'fabric.editor.editLink': 'Muuda linki',
  'fabric.editor.editMode.inviteToEditButton.title': 'Kutsu muutma',
  'fabric.editor.editorHelp': 'Toimetaja abi',
  'fabric.editor.emoji': 'Emoji',
  'fabric.editor.emoji.description': 'Mõtete 🎉 ja tunnete 😄 väljendamiseks kasuta emotikone',
  'fabric.editor.error': 'Viga',
  'fabric.editor.errorPanel': 'Vea paneel',
  'fabric.editor.errorPanel.description': 'Näita vigu värvilises paneelis',
  'fabric.editor.expand': 'Laienda',
  'fabric.editor.expand.description': 'Sisesta laiendus',
  'fabric.editor.feedbackDialog': 'Anna tagasisidet',
  'fabric.editor.feedbackDialog.description': 'Räägi meile oma uue muutja kasutamise kogemusest',
  'fabric.editor.filesAndImages': 'Failid ja pildid',
  'fabric.editor.filesAndImages.description': 'Lisa lehele pilte või muid faile',
  'fabric.editor.find': 'Otsi',
  'fabric.editor.findNext': 'Järgmise leidmine',
  'fabric.editor.findPrevious': 'Eelmise leidmine',
  'fabric.editor.findReplaceToolbarButton': 'Leia ja asenda',
  'fabric.editor.headerColumn': 'Päise veerg',
  'fabric.editor.headerRow': 'Päise rida',
  'fabric.editor.heading1': '1. pealkiri',
  'fabric.editor.heading1Description': 'Kasuta seda ülemise päisena',
  'fabric.editor.heading2': '2. pealkiri',
  'fabric.editor.heading2Description': 'Kasuta seda peamiste jaotiste jaoks',
  'fabric.editor.heading3': '3. pealkiri',
  'fabric.editor.heading3Description': 'Kasuta seda alamjaotiste ja rühma pealkirjade jaoks',
  'fabric.editor.heading4': '4. pealkiri',
  'fabric.editor.heading4Description': 'Kasuta seda sügavate pealkirjade jaoks',
  'fabric.editor.heading5': '5. pealkiri',
  'fabric.editor.heading5Description': 'Kasuta seda loendi esemete grupeerimiseks',
  'fabric.editor.heading6': '6. pealkiri',
  'fabric.editor.heading6Description': 'Kasuta seda alumise päiste puhul',
  'fabric.editor.help': 'Spikker',
  'fabric.editor.help.description': 'Sirvige kõiki klaviatuuri otseteid ja markdowni suvandeid',
  'fabric.editor.helpDialogTips': 'Vajuta {keyMap} dialoogi kiireks avamiseks igal ajal',
  'fabric.editor.horizontalRule': 'Jagaja',
  'fabric.editor.horizontalRule.description': 'Eralda sisu horisontaalse joonega',
  'fabric.editor.image': 'Pilt',
  'fabric.editor.info': 'Info',
  'fabric.editor.infoPanel': 'Teabepaneel',
  'fabric.editor.infoPanel.description': 'Tõsta teave esile värvilises paneelis',
  'fabric.editor.insertMenu': 'Sisesta',
  'fabric.editor.italic': 'Kaldkiri',
  'fabric.editor.keyboardShortcuts': 'Klaviatuuri otseteed',
  'fabric.editor.layoutFixedWidth': 'Tagasi keskele',
  'fabric.editor.layoutFullWidth': 'Täislaiusele',
  'fabric.editor.layoutWide': 'Laienda',
  'fabric.editor.leftSidebar': 'Vasak külgriba',
  'fabric.editor.link': 'Viide',
  'fabric.editor.link.description': 'Sisesta link',
  'fabric.editor.linkAddress': 'Lingi aadress',
  'fabric.editor.linkPlaceholder': 'Kleebi link',
  'fabric.editor.lists': 'Nimekirjad',
  'fabric.editor.markdown': 'Soodus',
  'fabric.editor.mediaAddLink': 'Lisa link',
  'fabric.editor.mention': 'Maini',
  'fabric.editor.mention.description': 'Kellelegi teate saamiseks maini teda',
  'fabric.editor.mergeCells': 'Ühenda lahtrid',
  'fabric.editor.moreFormatting': 'Vormindamise lisavalikud',
  'fabric.editor.normal': 'Tavaline tekst',
  'fabric.editor.note': 'Märkus',
  'fabric.editor.notePanel': 'Märkuste paneel',
  'fabric.editor.notePanel.description': 'Lisa värvilisse paneeli märkus',
  'fabric.editor.numberedColumn': 'Nummerdatud veerg',
  'fabric.editor.orderedList': 'Nummerdatud loend',
  'fabric.editor.orderedList.description': 'Loo korrapärane loend',
  'fabric.editor.other': 'Muud...',
  'fabric.editor.pastePlainText': 'Kleebi tavaline tekst',
  'fabric.editor.placeholderAltText': 'Kirjeldage seda pilti asetekstiga',
  'fabric.editor.placeholderText': 'Kohatäitja tekst',
  'fabric.editor.placeholderTextPlaceholder': 'Lisa kohatäitja tekst',
  'fabric.editor.quickInsert': 'Kiire sisestamine',
  'fabric.editor.redo': 'Tee uuesti',
  'fabric.editor.remove': 'Eemalda',
  'fabric.editor.replace': 'Asendamine',
  'fabric.editor.replaceAll': 'Asenda kõik',
  'fabric.editor.replaceWith': 'Asenda',
  'fabric.editor.rightSidebar': 'Parem külgriba',
  'fabric.editor.saveButton': 'Salvesta',
  'fabric.editor.selectLanguage': 'Vali keel',
  'fabric.editor.splitCell': 'Eralda lahtrid',
  'fabric.editor.status': 'Olek',
  'fabric.editor.status.description': 'Lisa kohandatud oleku silt',
  'fabric.editor.statusPlaceholder': 'Määra olek',
  'fabric.editor.strike': 'Läbikriipsutatud',
  'fabric.editor.subscript': 'Allindeks',
  'fabric.editor.success': 'Õnnestus',
  'fabric.editor.successPanel': 'Õnnestumise paneel',
  'fabric.editor.successPanel.description': 'Lisa värvilisse paneeli nõuandeid',
  'fabric.editor.superscript': 'Ülemindeks',
  'fabric.editor.supportAltText': 'Visuaalsete piirangute tõttu on asetekst kasulik ekraanilugereid kasutavate inimeste jaoks.',
  'fabric.editor.table': 'Tabel',
  'fabric.editor.table.description': 'Sisesta tabel',
  'fabric.editor.tableOptions': 'Tabeli valikud',
  'fabric.editor.taskPlaceholder': "Sisesta oma toiming, kasuta kellelegi määramiseks märki '@'.",
  'fabric.editor.textColor': 'Teksti värv',
  'fabric.editor.textStyles': 'Tekstistiilid',
  'fabric.editor.threeColumns': 'Kolm veergu',
  'fabric.editor.threeColumnsWithSidebars': 'Kolm veergu külgribadega',
  'fabric.editor.twoColumns': 'Kaks veergu',
  'fabric.editor.underline': 'Jooni alla',
  'fabric.editor.undo': 'Tühista',
  'fabric.editor.unlink': 'Eemalda link',
  'fabric.editor.unorderedList': 'Täpploend',
  'fabric.editor.unorderedList.description': 'Loo ebakorrapärane loend',
  'fabric.editor.viewMore': 'Näita rohkem',
  'fabric.editor.visit': 'Ava link uues aknas',
  'fabric.editor.warning': 'Hoiatus',
  'fabric.editor.warningPanel': 'Hoiatuse paneel',
  'fabric.editor.warningPanel.description': 'Lisa värvilisse paneeli ettevaatlikusele viitav märkus',
  'fabric.editor.wrapLeft': 'Aseta vasakule',
  'fabric.editor.wrapRight': 'Aseta paremale'
};